module.exports = __webpack_public_path__ + "media/site_templates/www.carpetcleaning.agency/images/about_us-fdbbc48d0e237730d6519bce80a75b49.jpg";